import React from 'react'

const renderColInCenter = (value) => {
  return <div style={{ display: 'flex', justifyContent: 'center', maxWidth: '120px' }}>{value}</div>
}

const renderCol = (value) => {
  return <div style={{ minWidth: '100px' }}>{value}</div>
}

const renderColWithWidth = (minWidth = '100px', value) => {
  return <div style={{ minWidth: minWidth }}>{value}</div>
}

export { renderColInCenter, renderCol, renderColWithWidth }
